/**
 * Centralized partner play links mapped by casino brand.
 */
import { trackRegisterClick } from '../utils/analytics';

export const PLAY_PARTNER_LINKS = {
  ipay9vip: 'https://www.ipay9aud.co/en-au/?ref=IPAY9C93A1',
  gucci9: 'https://guccii9au.net/RFKOALABET1',
  mrbean9: 'https://mrbean9au.com/RFKOALABET9',
  kingbet9: 'https://kingbet9.co/RFKOALABET13',
  me99: 'https://me99office.co/RFKOALABET99',
  spinaroo: 'https://pokepokemon9.com/RFKOALABET98',
  micky9: 'https://micky13.asia/RFKOALABET97',
  winnie777: 'https://winnie777.vip/RFKOALABET96',
  queen13: 'https://queen13au.com/RFKOALABET94',
  ipay9: 'https://i9aud.net/RFKOALABEY',
  rolex9: 'https://rolex9.net/RFKOALABETT',
  bigpay77: 'https://bigpay77.co/RFBPKOALABEY',
  bybid9: 'https://bybid9.net/RFKOLABET9',
  mrboom9: 'https://mrboom9.com/RFKOALABETSS',
} as const;

type PartnerBrand = keyof typeof PLAY_PARTNER_LINKS;

const PARTNER_BRAND_ALIASES: Record<string, PartnerBrand> = {
  ipay9vip: 'ipay9vip',
  ipay9: 'ipay9',
  kingbet9: 'kingbet9',
  king9: 'kingbet9',
  bigpay77: 'bigpay77',
  bp77: 'bigpay77',
  me99: 'me99',
  rolex9: 'rolex9',
  bybid9: 'bybid9',
  gucci9: 'gucci9',
  spinaroo: 'spinaroo',
  pokemon13: 'spinaroo',
  pokemon9: 'spinaroo',
  pkm9: 'spinaroo',
  mrbean9: 'mrbean9',
  winnie777: 'winnie777',
  micky9: 'micky9',
  queen13: 'queen13',
  mrboom9: 'mrboom9',
};

export function normalizeBrandKey(brand: string): string {
  return brand.toLowerCase().replace(/\sonline casino/g, '').replace(/\s+/g, '');
}

export function resolvePartnerBrand(brand: string): PartnerBrand | null {
  return PARTNER_BRAND_ALIASES[normalizeBrandKey(brand)] ?? null;
}

function getRandomPlayPartner(): { link: string; brand: PartnerBrand } {
  const brands = Object.keys(PLAY_PARTNER_LINKS) as PartnerBrand[];
  const brand = brands[Math.floor(Math.random() * brands.length)];
  return { link: PLAY_PARTNER_LINKS[brand], brand };
}

/**
 * Returns a random partner link.
 */
export function getRandomPlayLink(): string {
  return getRandomPlayPartner().link;
}

/**
 * Returns a brand-matched partner link; falls back to random.
 */
export function getPlayLinkByBrand(brand: string): string {
  const mappedBrand = resolvePartnerBrand(brand);
  if (mappedBrand) {
    return PLAY_PARTNER_LINKS[mappedBrand];
  }
  return getRandomPlayLink();
}

export function trackRegisterClickByBrand(brand: string): void {
  const mappedBrand = resolvePartnerBrand(brand);
  trackRegisterClick(mappedBrand ?? normalizeBrandKey(brand));
}

/**
 * Opens a brand-matched partner link in a new tab and tracks register_click.
 */
export function openPlayLinkByBrand(brand: string): void {
  const mappedBrand = resolvePartnerBrand(brand);
  const partner = mappedBrand
    ? { link: PLAY_PARTNER_LINKS[mappedBrand], brand: mappedBrand }
    : getRandomPlayPartner();

  trackRegisterClick(partner.brand);
  window.open(partner.link, '_blank', 'noopener,noreferrer');
}

/**
 * Opens a random partner link in a new tab and tracks register_click.
 */
export function openRandomPlayLink(): void {
  const { link, brand } = getRandomPlayPartner();
  trackRegisterClick(brand);
  window.open(link, '_blank', 'noopener,noreferrer');
}
